import {RootState} from '../rootReducer';
import {createSelector} from '@reduxjs/toolkit';
import {LicenceVerificationMode} from '@/constants';

export const userStatus = createSelector(
  [(state: RootState) => state.superAdminDashboard.isLoading],
  isLoading => isLoading,
);

export const userTabSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.manageUsers.userTab],
  userTab => userTab,
);

export const userSuccessSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.superAdminDashboardSuccess],
  userSuccess => userSuccess,
);

export const userFailureSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.superAdminDashboardFailure],
  userFailure => userFailure,
);

export const userDataSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.manageUsers.users],
  users => users,
);

export const userCurrentPageSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.manageUsers.currentPage],
  currentPage => currentPage,
);

export const userTotalPagesSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.manageUsers.totalPages],
  totalPages => totalPages,
);

export const userTotalResultSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.manageUsers.totalResults],
  totalResults => totalResults,
);

export const userNextPageSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.manageUsers.nextPage],
  nextPage => nextPage,
);

// Admin selectors
export const adminDataSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.adminManagement.admins],
  admins => admins || [],
);


export const adminCurrentPageSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.adminManagement.currentPage],
  adminCurrentPage => adminCurrentPage,
);

export const adminTotalPagesSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.adminManagement.totalPages],
  adminTotalPages => adminTotalPages,
);

export const adminTotalResultSelector = createSelector(
    [(state: RootState) => state.superAdminDashboard.adminManagement.totalResults],
  adminTotalResults => adminTotalResults,
);

export const adminNextPageSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.adminManagement.nextPage],
  adminNextPage => adminNextPage,
);

// Audit Logs selectors
export const auditLogsDataSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard?.auditLogs],
  auditLogs => auditLogs || [],
);

export const auditLogsSuccessSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard?.auditLogsSuccess],
  auditLogsSuccess => auditLogsSuccess,
);

export const auditLogsFailureSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard?.auditLogsFailure],
  auditLogsFailure => auditLogsFailure,
);

export const auditLogsCurrentPageSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard?.auditLogsCurrentPage],
  auditLogsCurrentPage => auditLogsCurrentPage,
);

export const auditLogsTotalPagesSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard?.auditLogsTotalPages],
  auditLogsTotalPages => auditLogsTotalPages,
);

export const auditLogsTotalResultSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard?.auditLogsTotalResults],
  auditLogsTotalResults => auditLogsTotalResults,
);

export const auditLogsNextPageSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard?.auditLogsNextPage],
  auditLogsNextPage => auditLogsNextPage,
);

// Access Modules List selectors
export const accessModulesListSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard?.accessModulesList],
  accessModulesList => accessModulesList || [],
);

export const accessModulesListSuccessSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard?.accessModulesListSuccess],
  accessModulesListSuccess => accessModulesListSuccess,
);

export const accessModulesListFailureSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard?.accessModulesListFailure],
  accessModulesListFailure => accessModulesListFailure,
);

export const accessControlRolesSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.accessControl.roles],
  roles => roles || [],
);

export const accessControlAccessModulesSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.accessControl.accessModules],
  accessModules => accessModules || [],
);

export const accessControlCurrentPageSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.accessControl.currentPage],
  currentPage => currentPage ?? 0,
);

export const accessControlTotalPagesSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.accessControl.totalPages],
  totalPages => totalPages ?? 0,
);

export const accessControlTotalResultsSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.accessControl.totalResults],
  totalResults => totalResults ?? 0,
);

export const accessControlNextPageSelector = createSelector(
  [(state: RootState) => state.superAdminDashboard.accessControl.nextPage],
  nextPage => nextPage ?? null,
);

// Licence Verification Selectors
export const licenceVerificationModeSelector = createSelector(
  [(state: RootState) => state?.superAdminDashboard?.licenceVerification?.mode],
  mode => mode ?? LicenceVerificationMode.Automatic,
);

export const licenceVerificationLastUpdatedSelector = createSelector(
  [(state: RootState) => state?.superAdminDashboard?.licenceVerification?.lastUpdated],
  lastUpdated => lastUpdated ?? null,
);